import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['element', 'errors', 'stripeToken']

  async connect() {
    const publishableKey = this.element.dataset.ibanPublishableKey
    if (!publishableKey) return

    while (!window.Stripe) await new Promise(r => setTimeout(r, 50))

    this.stripe = Stripe(publishableKey)
    const elements = this.stripe.elements()

    const supportedCountries = JSON.parse(this.element.dataset.ibanSupportedCountries)
    this.ibanElement = elements.create('iban', { supportedCountries })
    this.ibanElement.mount(this.elementTarget)

    this.ibanElement.on('change', (event) => {
      this.errorsTarget.textContent = event.error ? event.error.message : ''
    })
  }

  async submit(event) {
    event.preventDefault()

    const { token, error } = await this.stripe.createToken(this.ibanElement, {
      currency: this.element.dataset.ibanCurrency,
      account_holder_name: this.element.dataset.ibanAccountHolderName,
      account_holder_type: this.element.dataset.ibanAccountHolderType,
    })

    if (error) {
      this.errorsTarget.textContent = error.message
      return
    }

    this.stripeTokenTarget.value = token.id
    event.target.submit()
  }
}
